/**
 * @file_purpose  page for showing book an appointment
 * @author Sarmistha Mondal
 * @Date_Created 19/08/2024
 * @Date_Modified
 */

import React, { useState, useEffect, useRef } from "react";
import { CLabel, CSelect } from '@coreui/react';
import { useHistory, Link } from "react-router-dom";
import GeneralService from "src/apis/GeneralService";
import RouteURL from "src/apis/ApiURL";
import Constants from "src/Utility/Constants";
import moment from "moment";
import { IoCaretDown, IoCaretUp,IoCaretBack,IoCaretForward } from "react-icons/io5";
import { ToastContainer, toast } from "react-toastify";
import masterData from "../../../Utility/MasterData";
import Globe from '../../../assets/icons/globe.png'
import Calen from '../../../assets/icons/mnth_cal.png';

export default function BookAnAppointment() {
    const RAT_WEBSITE_ORIGIN="https://ems.redappletech.com";
    const history = useHistory();
    const _today = new Date();
    const _todayDateFormate = moment(_today).format("YYYY-MM-DD")
    const [days, setdays] = useState([]);
    const [lastDateOfWk, setLastDateOfWk] = useState();
    const [firstDateOfWk, setFirstDateOfWk] = useState();
    const [monthAndYr, setMonthAndYr] = useState();
    const [selectedMonth, setSelectedMonth] = useState(new Date);
    const [current_time, setCurrent_time] = useState();
    const [buttonDisable, setbuttonDisable] = useState(false);
    const [_date, _setDate] = useState(_todayDateFormate);
    const [_time, _setTime] = useState();
    const [errorMsg, setErrorMsg] = useState({ date: '', time: '' });
    const [totalMeetingTime, setTotalMeetingTime] = useState(0);
    const [salesPersonList, setSalesPersonList] = useState([]);
    const [Time, setTime] = useState([]);
    const [selectedIdId, setSelectedId] = useState({
        min: -1, max: -1,
    });

    let _current_time = moment(_today).add(30, 'minute').format("HH:mm");
    const timeSlot = [{ id: 0, time: '10:00', active: false }, { id: 1, time: '10:30', active: false }, { id: 2, time: '11:00', active: false }, { id: 3, time: '11:30', active: false }, { id: 4, time: '12:00', active: false }, { id: 5, time: '12:30', active: false }, { id: 6, time: '13:00', active: false }, { id: 7, time: '13:30', active: false }, { id: 8, time: '14:00', active: false }, { id: 9, time: '14:30', active: false }, { id: 10, time: '15:00', active: false }, { id: 11, time: '15:30', active: false }, { id: 12, time: '16:00', active: false }, { id: 13, time: '16:30', active: false }, { id: 14, time: '17:00', active: false }, { id: 15, time: '17:30', active: false }, { id: 16, time: '18:00', active: false }, { id: 17, time: '18:30', active: false }, { id: 18, time: '19:00', active: false }, { id: 19, time: '19:30', active: false }, { id: 20, time: '20:00', active: false }, { id: 21, time: '20:30', active: false }, { id: 22, time: '21:00', active: false }, { id: 23, time: '21:30', active: false },
    ]
    const [newArr, setnewArr] = useState(timeSlot);
    let _localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const [state, setState] = useState({
        timezone_name: _localTimeZone.split('/')[1],
        timezone: _localTimeZone
    });



    useEffect(() => {
        window.scrollTo(0, 0)
        weekDetails(_today);
        const monthandYr = moment(_today).format("MMMM YYYY");
        setMonthAndYr(monthandYr);
        setCurrent_time(_current_time)
        _getcalenderManageGetSalesUser()
        // console.log(_date);
    }, []);

    useEffect(() => {
        if (days.length > 0) {

            let dateInSeries = days.filter((element) => element == moment(new Date).format("YYYY-MM-DD"));
            // console.log('buttonDisable--', buttonDisable);
            // console.log(dateInSeries);
            if (dateInSeries.length == 0) {
                days.filter((element) => {
                    if (element > moment(new Date).format("YYYY-MM-DD")) {
                        setbuttonDisable(true);
                    } else {
                        setbuttonDisable(false);
                    }
                })

            }
            else { setbuttonDisable(false); setCurrent_time(_current_time) }
        }
        // console.log(days);
        // console.log(moment(_today).format("YYYY-MM-DD"));
        // console.log(_date, selectedIdId);

        if (_todayDateFormate >= firstDateOfWk && _todayDateFormate <= lastDateOfWk) {
            // console.log(1);
        } else if (_todayDateFormate <= firstDateOfWk && _todayDateFormate <= lastDateOfWk) setCurrent_time(null)
        else if (_todayDateFormate < firstDateOfWk && _todayDateFormate < lastDateOfWk) console.log(3);

    }, [days])


    const weekDetails = (dt) => {
        // console.log(new Date());        
        const _today = dt;
        const _startDay = _today.getDate() - _today.getDay() + (_today.getDay() === 0 ? -6 : 1);
        const _start = new Date(_today.setDate(_startDay))
        const end_ = new Date(_start);
        const _end = end_.setDate(_start.getDate() + 7);
        let getDates = [];
        const DAY = 24 * 60 * 60 * 1000;
        const monthandYr = moment(_today).format("MMMM YYYY");
        setMonthAndYr(monthandYr)
        setdays([])
        for (let newStart = _start.valueOf(); newStart < _end; newStart += DAY * 7) {
            for (let d = newStart; d < newStart + 7 * DAY; d += DAY) {
                let getDate = new Date(d);
                let finalDate = moment(getDate).format("YYYY-MM-DD");
                getDates.push(finalDate);
                setdays(getDates);
                setLastDateOfWk(getDates[6])
                setFirstDateOfWk(getDates[0])
            }
        }
    }


    const ForwordDate = (e) => {
        e.preventDefault();
        const _today = new Date(lastDateOfWk);
        _today.setDate(_today.getDate() + 1)
        weekDetails(_today)
        setCurrent_time(null)
        setnewArr([])
        setnewArr(timeSlot)
        _setTime()
    }


    const BackWordDate = (e) => {
        e.preventDefault();
        // console.log(firstDateOfWk);
        const _today = new Date(firstDateOfWk);
        _today.setDate(_today.getDate() - 7)
        weekDetails(_today)
        setCurrent_time(null)
        setnewArr([])
        setnewArr(timeSlot)
        _setTime()
    }

    const previousMonth = () => {
        setSelectedMonth();
        let currentDate = moment(new Date()).format("YYYY-MM-DD");
        let _firstDayOfPreviousMonth = moment(selectedMonth).subtract(1, 'months').startOf('month').format("YYYY-MM-DD");
        if (moment(new Date()).format("YYYY-MM") == moment(selectedMonth).subtract(1, 'months').format("YYYY-MM")) {
            weekDetails(new Date(currentDate));
        } else {
            weekDetails(new Date(_firstDayOfPreviousMonth));
        }
        // console.log(_firstDayOfPreviousMonth, selectedMonth, moment(new Date()).format("YYYY-MM"), moment(selectedMonth).subtract(1, 'months').format("YYYY-MM"));       

        const monthandYr = moment(_firstDayOfPreviousMonth).format("MMMM YYYY");
        setMonthAndYr(monthandYr)
        setSelectedMonth(_firstDayOfPreviousMonth)
        // setCurrent_time(null)       
        setCurrent_time('23:00')
        setnewArr([])
        setnewArr(timeSlot)
        _setTime()

    }


    const nextMonth = () => {
        setSelectedMonth()
        let _firstDayOfPreviousMonth = moment(selectedMonth).add(1, 'months').startOf('month').format("YYYY-MM-DD")
        weekDetails(new Date(_firstDayOfPreviousMonth));
        const monthandYr = moment(_firstDayOfPreviousMonth).format("MMMM YYYY");
        setMonthAndYr(monthandYr)
        // console.log(_firstDayOfPreviousMonth)
        setSelectedMonth(_firstDayOfPreviousMonth)
        // setCurrent_time(null)
        setnewArr([])
        setnewArr(timeSlot)
        _setTime()


    }


    const dateSelect = (e, day) => {
        e.preventDefault();
        // console.log(day, _date);
        setSelectedId((prevState) => ({
            ...prevState,
            min: -1,
            max: -1

        }));
        const selectDate = moment(_today).format("YYYY-MM-DD");
        _setDate(day)
        if (!_date) {
            setErrorMsg((prevFormValue) => {
                return { ...prevFormValue, date: false };
            });
        }

        if (day > selectDate) {

            setCurrent_time(null)
            setnewArr([])
            setnewArr(timeSlot)
            _setTime()
        } else {

            let current_time = moment(_today).add(30, 'minute').format("HH:mm")
            setCurrent_time(current_time)
            setnewArr([])
            setnewArr(timeSlot)
            _setTime()
        }
    };


    const timeSelect = (e, data, key) => {
        e.preventDefault();
        // console.log(data, key);
        // console.log(selectedIdId.min, selectedIdId.max);
        // console.log(_date, selectedIdId);
        if (!_date) {
            setErrorMsg((prevFormValue) => {
                return { ...prevFormValue, date: true };
            });
        } else {
            setErrorMsg((prevFormValue) => {
                return { ...prevFormValue, date: false };
            });
        }

        if (data.active == false) {
            newArr[key].active = true;
            newArr.filter(e => { if (e.id != key) e.active = false })
            _setTime(data)
        }
        setnewArr(newArr);
    }



    // const timeSelect = (e, data, key) => {
    //     e.preventDefault();
    //     // console.log(data, key);
    //     // console.log(selectedIdId.min, selectedIdId.max);
    //     // console.log(_date, selectedIdId);
    //     if (!_date) {
    //         setErrorMsg((prevFormValue) => {
    //             return { ...prevFormValue, date: true };
    //         });
    //     } else {
    //         setErrorMsg((prevFormValue) => {
    //             return { ...prevFormValue, date: false };
    //         });
    //     }

    //     if (data.active == false) {

    //         if ((selectedIdId.min == -1 && selectedIdId.max == -1)) {
    //             setSelectedId((prevState) => ({
    //                 ...prevState,
    //                 min: key,
    //                 max: key
    //             }));
    //             newArr[key].active = true;
    //             _setTime(oldArray => [...oldArray, data]);
    //         } else if (key > selectedIdId.max) {

    //             if ((key - selectedIdId.max) == 1) {
    //                 setSelectedId((prevState) => ({
    //                     ...prevState,
    //                     max: key
    //                 }));
    //                 newArr[key].active = true;
    //                 _setTime(oldArray => [...oldArray, data]);
    //             }

    //         } else if (key < selectedIdId.min) {
    //             if ((selectedIdId.min - key) == 1) {
    //                 setSelectedId((prevState) => ({
    //                     ...prevState,
    //                     min: key

    //                 }));
    //                 newArr[key].active = true;
    //                 _setTime(oldArray => [...oldArray, data]);
    //             }
    //         }


    //     } else {

    //         newArr[key].active = false;

    //         let theKeyPosition = _time.findIndex(p => p.time == data.time);
    //         let index = newArr.findIndex(p => p.time == data.time)
    //         // console.log(theKeyPosition);
    //         if (theKeyPosition == 0) {

    //             newArr[index].active = false;
    //             // _time.splice(theKeyPosition);
    //             // _time.filter(p => p.active == true)
    //         } else {
    //             for (let i = index + 1; i < newArr.length; i++) {
    //                 newArr[i].active = false;
    //             }
    //             let sort = _time.sort((a, b) => a.id - b.id).filter(p => p?.active == true)
    //             // console.log(sort);

    //             setSelectedId((prevState) => ({
    //                 ...prevState,
    //                 min: sort[0]?.id,
    //                 max: sort[sort?.length - 1]?.id
    //             }));
    //         }
    //         let newTime = _time.filter(p => p.active == true);
    //         _setTime(newTime)
    //     }

    //     setnewArr(newArr);

    // }







    // useEffect(() => {
    //     // console.log(_time);
    //     // console.log(1,);
    //     // console.log(_time, _time[_time.length - 1]);
    //     // if (_time[_time.length - 1].id )

    //     var result = _time.sort((a, b) => a.id - b.id).map(a => a.time);
    //     setTime(result)
    //     if (_time.length > 0) {

    //         let count = _time.length;
    //         let num = count * 30;
    //         var hours = Math.floor(num / 60);
    //         var minutes = num % 60;
    //         if (hours == 0) {
    //             setTotalMeetingTime(minutes + " min");
    //         } else if (minutes == 0) {
    //             if (hours == 1) setTotalMeetingTime(hours + ":00 hr");
    //             else setTotalMeetingTime(hours + ":00 hrs");
    //         } else setTotalMeetingTime(hours + ":" + minutes + " hrs");

    //     } else {
    //         setSelectedId((prevState) => ({
    //             ...prevState,
    //             min: -1,
    //             max: -1

    //         }));
    //     }

    // }, [_time.length])


    /**
       * @author Sarmistha Mondal
       * @Date_Created 21/08/2024
       * @Date_Modified 
       * @function async
       * @functionName _getcalenderManageGetSalesUser
       * @functionPurpose this function gets
       * Lists of Lead Medium
       *
       * @functionSuccess Success status and message.
       *
       * @functionError {Boolean} error is there.
       * @functionError {String} message  Description message.
       */
    const _getcalenderManageGetSalesUser = () => {
        GeneralService.apiGetCallRequestWithoutToken(RouteURL.calenderManageGetSalesUser)
            .then((res) => {

                if (res.status === Constants.API_RESPONSE_STATUS_SUCCESS) {
                    setSalesPersonList(res?.data);


                } else {
                    toast.error(res.message, {
                        position: toast.POSITION.BOTTOM_RIGHT,
                    });
                }
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    console.log(error);

                }

            });
    }


    // const sendHeight = () => {
    //     // Send the height of the iframe content to the parent page
    //     window.parent.postMessage(document.body.scrollHeight, '*');
    // }

    // // Send height initially and on content changes
    // window.addEventListener('load', sendHeight);
    // window.addEventListener('resize', sendHeight);

    // const observer = new MutationObserver(sendHeight);
    // observer.observe(document.body, { childList: true, subtree: true });

    const sendHeight = () => {

        var data = {
            source: 'ems.redappletech.com/appointment',
            value: document.body.scrollHeight
        };
        // window.parent.postMessage(document.body.scrollHeight, '*');
        window.parent.postMessage(data, RAT_WEBSITE_ORIGIN);
        // Send the height of the iframe content to the parent page
        // window.parent.postMessage(document.body.scrollHeight, '*');
    };

    // Debounce function to limit the number of times sendHeight is called
    const debounce = (func, delay) => {
        let timer;
        return function () {
            clearTimeout(timer);
            timer = setTimeout(func, delay);
        };
    };

    // Create debounced version of sendHeight
    const debouncedSendHeight = debounce(sendHeight, 100);

    // Send height initially and on content changes
    window.addEventListener('load', debouncedSendHeight);
    window.addEventListener('resize', debouncedSendHeight);

    // Observe changes in the DOM with a slight delay to ensure rendering is complete
    const observer = new MutationObserver(debouncedSendHeight);
    observer.observe(document.body, { childList: true, subtree: true });

    return (
        <>
            <body style={{ backgroundColor: "#fff" }}>

                <div className="appoinment_hed">
                    <h4>
                        BOOK AN APPOINTMENT
                    </h4>
                    <div className="booking_mid">
                        <h6 className="booking_team_hed">Our Sales Team</h6>

                        <div className="sales_team">
                            {salesPersonList.map(data => {
                                return (
                                    <> <div className="sales_team_inn">
                                        <div className="team_member1"><img src={data?.profile_pic} alt="" /></div>
                                        <div className="member_desig">
                                            <h6>{data?.name}</h6>
                                            <p>{data?.designation?.length > 25 ? data?.designation.substr(0, 22) + '...' : data?.designation}</p>
                                            <span><Link to='#' onClick={() => { window.open(data?.linkedin_profile_url, '_blank') }}><i class="fa-brands fa-linkedin-in"></i></Link></span>
                                        </div>
                                    </div>
                                    </>
                                )

                            })}
                        </div>



                        <div className="booking_calender">
                            <div className="row" >
                                <div className="col-sm-4">
                                    <div className="choose_date">
                                        <p> Choose Date and Time</p>
                                    </div>
                                </div>
                                <div className="col-sm-4">

                                    <div className="select_zone">
                                        <CLabel htmlFor="month"><img src={Globe} alt="" /> </CLabel>

                                        <CSelect
                                            custom
                                            name="timezone"
                                            id="timezone"
                                            onChange={(e) => {
                                                e.preventDefault();
                                                setState({
                                                    timezone_name: e.target.value.split('/')[1],
                                                    timezone: e.target.value
                                                })

                                            }}
                                            value={state.timezone}
                                        >
                                            <option value="">Select Time Zone</option>
                                            {masterData.timeZone.map((item, key) => {
                                                return <option key={key} value={item.zone}>
                                                    {item.name + ' ' + item.gmt}
                                                </option>
                                            })}
                                        </CSelect>
                                        <i class="fa-solid fa-chevron-down"></i>
                                    </div>

                                </div>
                                <div className="col-sm-4">
                                    <div className="choose_calender">
                                        <img src={Calen} alt="" />
                                        {monthAndYr}
                                        {(moment(new Date()).format("MMMM YYYY") != monthAndYr) && <IoCaretUp className="up_caret" onClick={previousMonth} />}<IoCaretDown className="dwn_caret" onClick={nextMonth} />
                                    </div>


                                    <div className="choose_calender choose_forward_back">
                                    <span className="choose_forward_back_span"><img src={Calen} alt="" />
                                        {monthAndYr}</span>
                                       <IoCaretForward className="up_caret" onClick={nextMonth} />
                                       {(moment(new Date()).format("MMMM YYYY") != monthAndYr) && <IoCaretBack className="dwn_caret"  onClick={previousMonth}  />}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="month_cal">
                            <div className="row">
                                {buttonDisable && <i class="fa-solid fa-caret-left dugdugi_lt" onClick={BackWordDate} />}

                                {days.map((day, key) => {
                                    return <div className="col">
                                        <div className="small_mnth" style={styles.calenderStyle} >
                                            <button type="button" style={{ color: _date == day ? '#3c4b64' : '', backgroundColor: _date == day ? '#FFAB40' : '', border: _date == day ? '1px solid #F7B731' : '' }}
                                                className={"btn " + ((moment(_today).format("YYYY-MM-DD") > moment(day).format("YYYY-MM-DD")) ? '' : '')}
                                                disabled={(moment(_today).format("YYYY-MM-DD") > moment(day).format("YYYY-MM-DD")) ? true : false}
                                                onClick={(e) => dateSelect(e, day)}>
                                                <span style={{ color: _date == day ? '#fff' : '' }}>{moment(day).format("ddd")}</span>
                                                <span className="small_date" style={{ color: _date == day ? '#fff' : '#4A4B4C' }}>{moment(day).format("DD")}</span>
                                            </button>
                                        </div>
                                    </div>
                                })}
                                <i class="fa-solid fa-caret-right dugdugi_rt" onClick={ForwordDate} />
                                {/* <IoCaretForward  /> */}
                            </div>
                            {errorMsg.date == true && <span style={{ color: "#e6302f" }}>* Select Date</span>}
                        </div>

                        <div className="calender_time">
                            {/* {newArr.map((data, key) => {
                                return <div className="calender_time_box" >
                                    <button type="button"
                                        className={"btn " + (current_time > data.time ? 'btn-outline-secondary' : '')}
                                        onClick={(e) => timeSelect(e, data, key)}
                                        style={{ ...styles.box, color: newArr[key].active == true ? '#fff' : '#13060B', fontWeight: 600, opacity: current_time > data.time ? '0.3' : '', backgroundColor: newArr[key].active == true ? '#FFAB40' : '', border: newArr[key].active == true ? '1px solid #F7B731' : '1px solid #ABABAB' }}
                                        disabled={((current_time > data.time) ? true : false)}
                                    >{data.time}</button>
                                </div>
                            })} */}
                            {newArr.map((data, key) => {
                                return <div className="calender_time_box" >
                                    <button type="button"
                                        className={"btn " + (current_time > data.time ? 'btn-outline-secondary' : '')}
                                        onClick={(e) => timeSelect(e, data, key)}
                                        style={{ ...styles.box, color: newArr[key].active == true ? '#fff' : '#13060B', fontWeight: 600, opacity: current_time > data.time ? '0.3' : '', backgroundColor: newArr[key].active == true ? '#FFAB40' : '', border: newArr[key].active == true ? '1px solid #F7B731' : '1px solid #ABABAB' }}
                                        disabled={((current_time > data.time) ? true : false)}
                                    >{data.time}</button>
                                </div>
                            })}

                        </div>
                        <div className="submit_book"
                            style={{ backgroundColor: (_date && _time) ? '#FFAB40' : '', border: (_date && _time) ? '1px solid #FFAB40' : '' }}
                        >
                            <div class="submit_book_lt">
                                <p style={{ color: (_date && _time) ? '#fff' : '#ABABAB' }}>{_date ? <><span style={{ fontWeight: 600 }}>{moment(_date).format("DD MMMM YYYY")}</span> {
                                    (_time ? (' | ' + (_time.time) + ' | ' + '30 min') : '')
                                } </>
                                    : "Select Date & Time"}</p>
                                {/* <p style={{ color: (_date && _time.length > 0) ? '#fff' : '#ABABAB' }}>{_date ? <><span style={{ fontWeight: 600 }}>{moment(_date).format("DD MMMM YYYY")}</span> {
                                    (_time.length > 0 ? (' | ' + (_time.length > 1 ? _time[0].time + ' - ' + _time.slice(-1)[0].time : _time[0].time) + ' | ' + totalMeetingTime) : '')
                                } </>
                                    : "Select Date & Time"}</p> */}

                                {/* <p style={{ color: (_date && _time.length > 0) ? '#fff' : '#ABABAB' }}>{_date ? (moment(_date).format("DD MMMM YYYY") + (_time.length > 0 ? (' | ' + (_time.length > 1 ? _time[0].time + ' - ' + _time.slice(-1)[0].time : _time[0].time) + ' | ' + totalMeetingTime) : '')) : "Select Date & Time"}</p> */}

                            </div>
                            <div class="submit_book_rt">
                                <button type="button" class="btn btn-danger"
                                    style={{ background: (_date && _time) ? '#E84C3D' : '#DFDFDF' }}
                                    onClick={() =>
                                        history.push({
                                            pathname: "/contact-form/appointment_calender",
                                            state: { date: _date, time: Time.toString(), timeBook: _time.time, timeDuration: '30 min', timeZone: state }
                                        })
                                    } disabled={(_date && _time) ? false : true}>
                                    Book Now <i class="fa-solid fa-angle-right"></i></button>

                                {/* <button type="button" class="btn btn-danger"
                                    style={{ background: (_date && _time.length > 0) ? '#E84C3D' : '#DFDFDF' }}
                                    onClick={() =>
                                        history.push({
                                            pathname: "/contact-form/appointment_calender",
                                            state: { date: _date, time: Time.toString(), timeBook: _time[0].time + ' - ' + _time.slice(-1)[0].time, timeDuration: totalMeetingTime, timeZone: state }
                                        })
                                    } disabled={(_date && _time.length > 0) ? false : true}>
                                    Book Now <i class="fa-solid fa-angle-right"></i></button> */}
                            </div>
                        </div>
                    </div>

                </div>

            </body>



        </>


    )
}

const styles = {
    box: {
        width: 100,
        height: 60,
        padding: 18,
        textAlign: 'center',
        margin: 10,
        boxShadow: `rgba(0, 0, 0, 0.02) 0px 1px 3px 0px, rgba(27, 31, 35, 0.15) 0px 0px 0px 1px`
    },

}
